module.exports = __webpack_public_path__ + "fonts/ArchitectsDaughter-Regular.05d70602.ttf";